<template>
  <div class="ctLightBlue d-flex justify-center align-center"
       style="width: 100%; height: 260px; cursor: pointer"
       @click="showAddStepDialog()"
       v-ripple>
    <div class="text-center">
      <v-icon color="kbBlue"
              size="45px">
        mdi-plus-circle
      </v-icon>
      <span class="kbBlue--text d-block"
            style="font-size: 24px">
        {{ $t('general.addStep') }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      wasImageLoadedCorrectly: false
    }
  },
  methods: {
    checkProfileImageLoad (value) {
      this.wasImageLoadedCorrectly = value
    },
    showAddStepDialog () {
      this.$emit('showAddStepDialog')
    }
  }
}
</script>
